<template>
	<div class="login">
		<div class="login-logo">
			<a href="/">
				<img src="../assets/logo4.png" />
			</a>
		</div>
		<div class="container">
			<div class="content-wrapper">
				<h4 class="content-titel">设置密码</h4>
				<el-form :model="resetPsw" ref="resetPsw" :rules="rules" class="resetPswForm">
					<div class="list-group">
						<el-form-item class="list-group-item" prop="domain">
							<el-input readonly="readonly" v-model="resetPsw.account"></el-input>
						</el-form-item>
						<el-form-item class="list-group-item" prop="password">
							<el-input type="password" v-model="resetPsw.password" auto-complete="off" placeholder="密码"> </el-input>
							<!-- <div class="tip" v-if="pass.tipOne">{{pass.tipOne}}</div> -->
							<div class="tip">
								<span v-show="resetPsw.show_password_warning && resetPsw.company_password_strength == 1">管理员开启了密码强度设置，密码长度最少6位，必须包含大写字母、小写字母、特殊字符中的两项</span>
								<span v-show="resetPsw.show_password_warning && resetPsw.company_password_strength == 2">管理员开启了密码强度设置，密码长度最少8位，必须包含大写字母、小写字母、特殊字符</span>
							</div>
						</el-form-item>
						<el-form-item class="list-group-item" prop="repeat_pwd">
							<el-input type="password" v-model="resetPsw.repeat_pwd" placeholder="确认密码" auto-complete="off"> </el-input>
							<div class="tip" v-if="pass.tipReset">{{ pass.tipReset }}</div>
						</el-form-item>
					</div>
					<el-form-item>
						<el-button @click.stop.prevent="onResetPsw()" :disabled="!canSubmit" class="btn">
							<span v-if="!loading">设置密码</span>
							<span v-if="loading">
								<span>设置中</span>
								<i class="el-icon-loading"></i>
							</span>
						</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>

		<div class="copyright clearfix small">
			<div>Copyright 2013-2022 上海驻云信息科技有限公司</div>
			<div>
				Powered by
				<a href="https://cloudcare.cn/" target="_blank" class="text-primary new-block">cloudcare.cn</a>
			</div>
		</div>
	</div>
</template>
<script>
import STORE_CONST from '../store/consts'
import ElButton from '../../node_modules/element-ui/packages/button/src/button'
import ElInput from '../../node_modules/element-ui/packages/input/src/input'
import { PasswordStrengthRegExp } from '../config'
export default {
	components: {
		ElInput,
		ElButton,
	},
	name: 'resetPsw',
	data() {
		let pass = (rule, value, callback) => {
			let level = this.resetPsw.company_password_strength
			var uppercasePattern = PasswordStrengthRegExp.uppercasePattern
			var lowercasePattern = PasswordStrengthRegExp.lowercasePattern
			var sysbolPattern = PasswordStrengthRegExp.sysbolPattern
			var uppercaseRes = uppercasePattern.test(value)
			var lowercaseRes = lowercasePattern.test(value)
			var sysbolRes = sysbolPattern.test(value)
			if (value.length) {
				this.resetPsw.show_password_warning = false
				if (level === '1') {
					if (value.length >= 6 && ((lowercaseRes && uppercaseRes) || (lowercaseRes && sysbolRes) || (uppercaseRes && sysbolRes))) {
						callback()
					} else {
						callback(new Error('密码长度最少6位，必须包含大写字母、小写字母、特殊字符中的两项'))
					}
				} else if (level === '2') {
					if (value.length >= 8 && lowercaseRes && uppercaseRes && sysbolRes) {
						callback()
					} else {
						callback('密码长度最少8位，必须包含大写字母、小写字母、特殊字符')
					}
				} else {
					// level === 0
					callback()
				}
			} else {
				callback(new Error('请输入密码'))
			}
			if (this.resetPsw.repeat_pwd !== '') {
				this.$refs.resetPsw.validateField('repeat_pwd')
			}
		}
		let checkPass = (rule, value, callback) => {
			if (value === '' && this.resetPsw.password !== '') {
				callback(new Error('请再次输入密码'))
			} else if (value !== this.resetPsw.password) {
				callback(new Error('两次输入密码不一致!'))
			} else {
				callback()
			}
		}
		return {
			resetPsw: {
				account: this.$route.query.account || 'test@me.com',
				password: '',
				repeat_pwd: '',
				company_password_strength: this.$route.query.password_strength || 0,
				show_password_warning: this.$route.query.password_strength !== '0',
			},
			pass: {
				tipOne: '',
				tipReset: '',
			},
			loading: false,
			canSubmit: false,
			rules: {
				password: [{ validator: pass, trigger: 'blur' }],
				repeat_pwd: [{ validator: checkPass, trigger: 'blur' }],
			},
		}
	},
	methods: {
		onResetPsw() {
			this.loading = true
			let params = {
				code: this.$route.query.code,
				account: this.$route.query.account,
				pwd: this.resetPsw.password,
			}
			this.$store
				.dispatch(STORE_CONST.ACCOUNT.RSET_PSWD, params)
				.then((res) => {
					this.loading = false
					this.$notify({
						message: '重置密码成功, 请登录。',
						type: 'success',
					})
					this.$router.push('/login')
				})
				.catch(() => {
					this.loading = false
				})
		},
		resetFields() {
			this.$refs['forgetPswForm'].resetFields()
		},
	},
	watch: {
		resetPsw: {
			handler: function (newVal, oldVal) {
				const that = this
				if (this.$refs['resetPsw']) {
					this.$refs['resetPsw'].validate(function (valid) {
						that.canSubmit = valid
					})
				}
			},
			deep: true,
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" rel="stylesheet/scss">
@import '../assets/css/variable.scss';

.login {
	.el-form-item-content {
		width: 100%;
	}
	.resetPswForm {
		.tip {
			line-height: 1.2;
			text-align: left;
		}
		.el-form-item {
			&.is-error {
				margin-bottom: 32px;
				text-align: left;
				.el-form-item__error {
					line-height: 1.2;
				}
			}
		}
	}
	.el-form {
		.list-group-item {
			.el-form-item__content {
				margin: 0 auto;
				width: 300px;
				.reset-account {
					width: 276px;
					height: 54px;
					line-height: 54px;
					text-align: left;
					padding: 0 20px;
				}
			}
		}
		.list-group {
			margin: 20px 0;
		}
		.btn {
			font-size: 16px;
			border-radius: 0;
		}
	}
}
</style>



// WEBPACK FOOTER //
// reset-password.vue?b9e540b8